// src/pages/Contact.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import api from '../api';
import './Contact.css';

const formVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2 } }
};

const fieldVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
};

const infoVariants = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0 }
};

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sending, setSending] = useState(false);
  const [ok, setOk] = useState(false);
  const [error, setError] = useState('');

  const onChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setOk(false);

    try {
      setSending(true);
      await api.post('/contact', form);
      setOk(true);
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.message || 'No se pudo enviar tu mensaje.';
      setError(msg);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Animated background blob */}
      <motion.div
        className="blob"
        animate={{ scale: [1, 1.2, 1], rotate: [0, 15, 0] }}
        transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
      />

      <motion.h1
        className="contact-title"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        Contáctanos
      </motion.h1>

      <motion.div className="contact-grid" initial="hidden" animate="visible">
        {/* Contact Form */}
        <motion.form className="contact-form" variants={formVariants} onSubmit={onSubmit}>
          {ok && (
            <motion.div
              variants={fieldVariants}
              className="alert-success"
              style={{ padding: '10px', borderRadius: 8, background: '#e6ffed', color: '#166534' }}
            >
              ¡Mensaje enviado! Te responderemos pronto.
            </motion.div>
          )}
          {error && (
            <motion.div
              variants={fieldVariants}
              className="alert-error"
              style={{ padding: '10px', borderRadius: 8, background: '#fee2e2', color: '#991b1b' }}
            >
              {error}
            </motion.div>
          )}

          <motion.div variants={fieldVariants} className="field-group">
            <input
              type="text"
              name="name"
              placeholder="Tu nombre"
              value={form.name}
              onChange={onChange}
              required
            />
          </motion.div>

          <motion.div variants={fieldVariants} className="field-group">
            <input
              type="email"
              name="email"
              placeholder="Correo electrónico"
              value={form.email}
              onChange={onChange}
              required
            />
          </motion.div>

          <motion.div variants={fieldVariants} className="field-group">
            <textarea
              name="message"
              rows={4}
              placeholder="Tu mensaje"
              value={form.message}
              onChange={onChange}
              required
            />
          </motion.div>

          <motion.button
            type="submit"
            className="btn btn-primary"
            variants={fieldVariants}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            disabled={sending}
          >
            {sending ? 'Enviando…' : 'Enviar mensaje'}
          </motion.button>
        </motion.form>

        {/* Info & Map */}
        <motion.div
          className="contact-info"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={infoVariants}
          transition={{ delay: 0.3, duration: 1 }}
        >
          <div className="map">
            <iframe
              title="Ubicación"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d898.3625478981461!2d-99.53099412366105!3d19.40497846216279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d20b5bb1b72471%3A0xb60f1e8cebe6df55!2sFARMACIAS%20SIMILARES!5e1!3m2!1ses!2smx!4v1757442935327!5m2!1ses!2smx"
              allowFullScreen
              loading="lazy"
            />
          </div>

          <motion.div
            className="info-details"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            <p><strong>Horario:</strong> Lun - Vie: 09:00 - 18:00</p>
            <p><strong>Teléfono:</strong> +52 55 1234 5678</p>
            <p><strong>Dirección:</strong> Francisco I. Madero 6, Xonacatlan de Vicencio, 52060 Xonacatlán, Méx.</p>
          </motion.div>
        </motion.div>
      </motion.div>
    </div>
  );
}
